// Application specific configuration (environment based)
// We expose a function instead of an object to make sure dotenv has been called before the config itself is defined
// Otherwise all process.env.XXX are undefined.
const getRuntimeConfig = () => ({
  isLocal: process.env.APP_BASE_URL?.includes('localhost'),
  isProduction: process.env.STAGE === 'prod',
  application: {
    namespace: process.env.APP_NAMESPACE,
    baseUrl: process.env.APP_BASE_URL,
    environment: process.env.APP_ENVIRONMENT,
    subStores: {
      extras: 'extras',
      additionals: 'additionals',
      services: 'services'
    },
    kakaoAPIKey: process.env.KAKAO_MAP_JS_KEY,
    stage: process.env.STAGE
  },
  api: {
    // Define parameters specific to the API (environment-based or not)
    global: process.env.API_GLOBAL_BASE_URL,
    orderBack: process.env.ORDER_BACK_API_URL,
    checkoutApi: process.env.CHECKOUT_API_URL,
    extraBack: process.env.EXTRA_BACK_API_URL
  },
  dato: {
    // Define parameters specific to the content API (environment-based or not)
    baseUrl: process.env.DATO_BASE_URL,
    token: process.env.DATO_TOKEN
  },
  google: {
    // Define parameters specific to google services
    gtmKey: process.env.GTM_KEY,
    placesKey: process.env.PLACES_API_KEY
  },
  build: {
    // Define parameters specific to the build environment (most likely environment-based)
    mode: process.env.NODE_ENV // "development" | "production"
  },
  // feature flags
  feature: {
    activatedLocales: process.env.FF_ACTIVATED_LOCALES,

    wallboxMarketsLocales: process.env.WALLBOX_MARKETS_LOCALES,
    manuallyTrackEvents: process.env.MANUALLY_TRACK_EVENTS === 'true',
    activateOptimizely: process.env.ACTIVATE_OPTIMIZELY === 'true',
    showFooterFuture: process.env.ACTIVATE_FOOTER_V2 === 'true',
    showKakaoMaps: process.env.ACTIVATE_KAKAO_MAP_V2 === 'true',
    isLoginNavEnabled: process.env.ACTIVATE_NEW_LOGIN_NAV === 'true',
    showNewSupportDrawer: process.env.SHOW_NEW_SUPPORT_DRAWER === 'true',
    activateNonPrimaryDriverExtras: process.env.ACTIVATE_NON_PRIMARY_DRIVER_EXTRAS === 'true'
  },
  webshopv2: {
    tempBlockWebshop: process.env.TEMP_BLOCK_WEBSHOP === 'true',
    unlockTempBlockWebshopKey: process.env.UNLOCK_TEMP_BLOCK_WEBSHOP_KEY,
    windowShopperKey: process.env.WINDOW_SHOPPER_KEY
  },
  stripeApi: process.env.STRIPE_API_BASE_URL
});

export default getRuntimeConfig;
